// Suggested starter securities for a brand-new user with an empty watchlist. These are
// broad, liquid, widely-held ETFs that give someone a sensible first set to watch while
// they learn the app, spanning US large cap, tech, gold, silver, and bitcoin. They are
// suggestions only: each is added through the normal validated add path, so one that the
// data provider does not recognize simply will not stick.

export interface StarterSymbol {
  symbol: string;
  /** Short human label shown next to the ticker on a suggestion chip. */
  label: string;
}

export const STARTER_SYMBOLS: StarterSymbol[] = [
  { symbol: "SPY", label: "S&P 500" },
  { symbol: "QQQ", label: "Nasdaq 100" },
  { symbol: "GLD", label: "Gold" },
  { symbol: "SLV", label: "Silver" },
  { symbol: "IBIT", label: "Bitcoin" },
];
